import { IconNames } from './IconNames';
import { BuilderInputOptions } from '@/types/builder';

type IconEnumFieldParams = {
  name: string;
  required?: boolean;
  defaultValue?: string | null;
  helperText?: string;
  showIf?: (options: BuilderInputOptions) => boolean;
};

export const iconInput = ({ ...props }: IconEnumFieldParams) => {
  return {
    type: 'enum',
    enum: [{ label: 'None', value: '' }, ...IconNames.map((n) => ({ label: n, value: n }))],
    ...props,
  };
};
